
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"alpha"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"25","height":"25"}},[_c('path',{attrs:{"fill":"#D9D9D9","d":"M.198.658h24v24h-24z"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M7.198 22.657v-9.15a4.12 4.12 0 01-2.137-1.4c-.576-.7-.863-1.516-.863-2.45v-7h2v7h1v-7h2v7h1v-7h2v7c0 .934-.288 1.75-.863 2.45a4.12 4.12 0 01-2.137 1.4v9.15h-2zm10 0v-8h-3v-7c0-1.383.487-2.562 1.463-3.536.974-.976 2.153-1.463 3.537-1.463v20h-2z"}})])])
          )
        }
      }
    